import { CaseDto } from '../../models/contracts/project-dto';
import { v4 as uuidv4 } from 'uuid';
import { getOldNewIdPairs } from '@app/shared/helpers';

export const cloneCase = (caseToClone: CaseDto): CaseDto => {
  const oldNewMultipleIdPairs = getOldNewIdPairs(caseToClone.multiples, (m) => m.multipleId);

  return {
    ...caseToClone,
    caseId: uuidv4(),
    multiples: [
      ...caseToClone.multiples.map((item) => ({
        ...item,
        multipleId: oldNewMultipleIdPairs[item.multipleId],
      })),
    ],
    forecasts: [
      ...caseToClone.forecasts.map((item) => ({
        ...item,
        forecastId: uuidv4(),
        multipleProbabilities: [
          ...item.multipleProbabilities.map((multipleProbability) => ({
            ...multipleProbability,
            multipleId: oldNewMultipleIdPairs[multipleProbability.multipleId],
          })),
        ],
        netDebtValues: [...item.netDebtValues.map((netDebtValue) => ({ ...netDebtValue }))],
        inputs: { ...item.inputs, inputId: uuidv4() },
      })),
    ],
  };
};
